function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { serviceModel } from "../../models";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ServiceNameTextField(_ref) {
  let {
    testid,
    disabled = false,
    serviceNameBlacklist
  } = _ref;
  const {
    control,
    watch
  } = useFormContext();
  const isBundle = Boolean(watch('bundle'));
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "serviceName",
    rules: {
      validate: n => serviceModel.validateName(n, {
        nameBlacklist: serviceNameBlacklist,
        isBundleName: isBundle
      })
    },
    render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
      autoFocus: true,
      disabled: disabled,
      label: isBundle ? 'Bundle name' : 'Service name',
      "data-testid": testid
    }))
  });
}